export default "__VITE_ASSET__CIR1Ii5q__"